export default __webpack_public_path__ + "img/sterlite technologies limited.b831eb76.jpg";